<div class="left-modal full dark">
  <div class="close"  (click)="close()"></div>

  @if (editable) {
    <div class="delete"  (click)="delete()"></div>
  }
  @if (editable && showEditButton) {
    <div class="edit"  (click)="edit()"></div>
  }

  <div class="full-image" (swipeleft)="previous()" (swiperight)="next()">
    <div class="slider-arrow next" (click)="next()"></div>
    <div class="slider-arrow previous" (click)="previous()"></div>

    @if (_gS.getFileType(filesList[position].fileExtension) == 'image') {
      <div class="imageConteiner" appImagefull>
        <img [src]="filesList[position][urlProperty]" imageLoader imageFull="true" alt="" (load)="loadImage()">
      </div>
    } @else {
      @if (_gS.getFileType(filesList[position].fileExtension) == 'excel') {
        <a class="button button-download" [href]="filesList[position][urlProperty]" target="_blank">
          {{'Download' | translate}}
          {{filesList[position][fileNameProperty].length > 30 ? (filesList[position][fileNameProperty]| slice: 0: 30) + '...' : filesList[position][fileNameProperty]}}
        </a>
      } @else {
        <div class="pdf-wrapper">
          @if (_gS.getFileType(filesList[position].fileExtension) == 'pdf') {
            <div id="adobe-dc-view"></div>
          }
        </div>
      }
    }


  </div>
</div>
@if (view == 'delete') {
  <div class="center-modal">
    <div class="close" (click)="view = ''"></div>
    @if (!loading) {
      <div class="modal-container">
        <h1>{{'Delete file' | translate}}</h1>
        <form #form="ngForm" (ngSubmit)="deleteConfirm()" novalidate>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" value="{{'Confirm' | translate}}">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="view = ''">{{'Cancel' | translate}}</a>
          </div>
        </form>
      </div>
    }
  </div>
}